import { ServiceAddress } from './service-address';
export class ServiceAddressRequest{

    serviceAddress: ServiceAddress;
}